/**
 * Generate CSS from Background Control attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { generateResponsiveCSS } from '../../common';
import {
	BackgroundAttributes,
	BackgroundValues,
	ResponsiveBreakpoint,
} from '../types';
import {
	generateBackgroundCSSRules,
	generateBackgroundOverlayRules,
} from './rules';

/**
 * Generate complete responsive CSS for background control group
 */
export const getBackgroundCSS = (
	attributes: BackgroundAttributes,
	selector: string = '',
): string => {
	const baseCSS = generateResponsiveCSS(
		attributes,
		selector,
		( values: BackgroundValues, _breakpoint: ResponsiveBreakpoint ) => {
			return generateBackgroundCSSRules( values );
		},
	);

	// Generate overlay CSS separately for .background-overlay class
	const overlayCSS = generateResponsiveCSS(
		attributes,
		`${ selector } .background-overlay`,
		( values: BackgroundValues, _breakpoint: ResponsiveBreakpoint ) => {
			return generateBackgroundOverlayRules( values );
		},
	);

	return baseCSS + overlayCSS;
};
